if ( typeof InfiniteScroll !== 'function' ) {

  class InfiniteScroll extends HTMLElement {

    constructor() {
      super();

      this.isLoading = false;
      this.hasNextPage = true;
      this.currentPage = parseInt(this.dataset.currentPage) || 1;
      this.totalPages = parseInt(this.dataset.totalPages) || 1;
      this.paginationUrl = this.dataset.paginationUrl || '';

      this.productGrid = document.getElementById('main-collection-product-grid');
      this.loadMoreBtn = this.querySelector('.infinite-scroll__load-more');
      this.loader = this.querySelector('.infinite-scroll__loader');

      if ( this.loadMoreBtn ) {
        this.loadMoreBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.loadNextPage();
        });
      }

      // Infinite scroll on scroll event
      if ( this.dataset.mode === 'scroll' ) {
        this.initIntersectionObserver();
      }
    }

    initIntersectionObserver() {
      const options = {
        root: null,
        rootMargin: '200px',
        threshold: 0
      };

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if ( entry.isIntersecting && !this.isLoading && this.hasNextPage ) {
            this.loadNextPage();
          }
        });
      }, options);

      this.observer.observe(this);
    }

    loadNextPage() {
      if ( this.isLoading || !this.hasNextPage ) return;

      this.isLoading = true;
      this.showLoader();

      const nextPage = this.currentPage + 1;
      const url = this.getPageUrl(nextPage);

      fetch(url)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          // Get new products
          const newProducts = doc.querySelectorAll('#main-collection-product-grid .product-item, #main-collection-product-grid [data-product-item]');

          if ( newProducts.length > 0 ) {
            newProducts.forEach(product => {
              this.productGrid.appendChild(product);
            });
          }

          // Update current page
          this.currentPage = nextPage;

          // Check if there are more pages
          if ( this.currentPage >= this.totalPages ) {
            this.hasNextPage = false;
            this.hideLoadMore();
            this.hideLoader();
            if ( this.observer ) {
              this.observer.disconnect();
            }
          }

          // Dispatch event for other components
          const event = new CustomEvent('infinite-scroll:loaded', {
            detail: { page: nextPage, products: newProducts.length }
          });
          document.dispatchEvent(event);

          this.isLoading = false;
          this.hideLoader();
        })
        .catch(error => {
          console.error('Infinite scroll error:', error);
          this.isLoading = false;
          this.hideLoader();
        });
    }

    getPageUrl(page) {
      // Handle different URL patterns
      let url = window.location.href;

      // Remove any existing page parameter
      url = url.replace(/page=\d+/, '');
      url = url.replace(/[?&]page=\d+/, '');

      // Add page parameter
      const separator = url.includes('?') ? '&' : '?';
      return `${url}${separator}page=${page}`;
    }

    showLoader() {
      if ( this.loader ) {
        this.loader.classList.add('is-loading');
      }
      if ( this.loadMoreBtn ) {
        this.loadMoreBtn.classList.add('is-loading');
        this.loadMoreBtn.disabled = true;
      }
    }

    hideLoader() {
      if ( this.loader ) {
        this.loader.classList.remove('is-loading');
      }
      if ( this.loadMoreBtn ) {
        this.loadMoreBtn.classList.remove('is-loading');
        this.loadMoreBtn.disabled = false;
      }
    }

    hideLoadMore() {
      if ( this.loadMoreBtn ) {
        this.loadMoreBtn.style.display = 'none';
      }
    }

  }

  if ( typeof customElements.get('infinite-scroll') == 'undefined' ) {
    customElements.define('infinite-scroll', InfiniteScroll);
  }

}
